module.exports = __webpack_public_path__ + "static/mediatek_logo-16cbe7a8b73610682dfff3497926853a.svg";